export default __webpack_public_path__ + "static/Visiomate_Orangeline_Case_Study-9cf23cb0b090500510e57dfaec40c26e.pdf";